const eventMap = new Map<string, Set<EventListener>>();

function subscribeWeb(eventName: string, listener: EventListener) {
    if (!eventMap.has(eventName)) {
        eventMap.set(eventName, new Set());
    }

    const listeners = eventMap.get(eventName)!;

    if (!listeners.has(listener)) {
        document.addEventListener(eventName, listener);
        listeners.add(listener);
    }
}


function unsubscribeWeb(eventName: string, listener: EventListener) {
    const listeners = eventMap.get(eventName);
    if (listeners && listeners.has(listener)) {
        document.removeEventListener(eventName, listener);
        listeners.delete(listener);
    }
}

function publishWeb(eventName: any, data: any) {
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
}

const webNavigate = (value: string) => {
    publishWeb('changeRoute', value);
}

const reloadHeader = (value: boolean) => {
    publishWeb('reloadHeader', value);
}

const webRoute = (value: string) => {
    publishWeb('webChangeSidebar', value);
}

const webLoadingTrue = () => {
    publishWeb('loadingWeb', true);
}
const webLoadingFalse = () => {
    publishWeb('loadingWeb', false);
}


export {
    webNavigate,
    publishWeb, subscribeWeb, unsubscribeWeb, webLoadingTrue, webLoadingFalse, webRoute, reloadHeader
}


